<div
	[ngClass]="{'bg-blue-400/20 rounded-l-lg': day.isToday}"
	[style.minHeight.px]="day.rowMinHeightPx"
	class="flex h-full min-h-0 flex-row items-stretch gap-1 pl-2 xl:gap-2"
>
	<span
		[ngClass]="{
			'mt-2 xl:mt-3': enabledTimes.projecthoursEnabled,
			'mb-2 xl:mb-3': enabledTimes.workinghoursEnabled,
		}"
		class="self-center whitespace-nowrap"
	>
		{{ day.date | dfnsFormat: 'EEE d.MM.' }}
	</span>
	<div class="flex flex-1 self-stretch flex-col items-stretch gap-1 xl:gap-2 pl-2">
		@if (enabledTimes.projecthoursEnabled) {
		<div class="mt-2 flex min-h-0 flex-1 items-center xl:mt-3 w-full">
			<div class="flex items-center rounded-lg border border-muted h-8 gap-1 w-full">
				<button
					(click)="createProject.emit()"
					class="!min-w-0 whitespace-nowrap h-8 !leading-8 !px-2 flex-auto flex-shrink-0"
					mat-button
				>
					<div class="flex items-center gap-2 text-base">
						<mat-icon class="!w-[1em] !h-[1em] !text-[1em]">add</mat-icon>
						<span class="hidden 2xl:inline">{{ 'timer.newProjectTime' | translate }}</span>
					</div>
				</button>
			</div>
		</div>
		} @if (enabledTimes.workinghoursEnabled) {
		<div class="mb-2 flex min-h-0 flex-1 items-center xl:mb-3">
			@if ((workinghoursCanCreate$ | async) || (workinghoursCanCreateAbsences$ | async)) {
			<div class="flex items-center rounded-lg border border-muted h-8 gap-1">
				@if (workinghoursCanCreate$ | async) {
				<button
					(click)="createWorking.emit()"
					class="!min-w-0 h-8 !px-2 flex-auto flex-shrink-0"
					mat-button
				>
					<div class="flex items-center gap-2 text-base">
						<mat-icon class="!w-[1em] !h-[1em] !text-[1em]">add</mat-icon>
						<span class="hidden 2xl:inline">{{ 'timer.newWorkingTime' | translate }}</span>
					</div>
				</button>
				} @if (workinghoursCanCreateAbsences$ | async) {
				<button
					(click)="createAbsence.emit()"
					[matTooltip]="'comego.createAbsence' | translate"
					class="!size-8 !min-w-8 !p-0 !rounded-l-none !rounded-r flex items-center justify-center flex-shrink-0"
					mat-button
				>
					<div class="flex items-center gap-2 text-base">
						<mat-icon class="!w-[1em] !h-[1em] !text-[1em] ml-2">beach_access</mat-icon>
					</div>
				</button>
				}
			</div>
			}
		</div>
		}
	</div>
	<div class="flex flex-1 self-stretch flex-col items-stretch gap-1 xl:gap-2">
		@if (enabledTimes.projecthoursEnabled) {
		<div class="mt-2 flex min-h-0 flex-1 items-center xl:mt-3">
			<button
				(click)="projectRowToggle.emit()"
				class="ml-4"
				mat-icon-button
				type="button"
			>
				<mat-icon>{{ day.projectRowsCollapsed ? 'arrow_drop_down' : 'arrow_drop_up' }}</mat-icon>
			</button>
		</div>
		} @if (enabledTimes.workinghoursEnabled) {
		<div class="mb-2 flex min-h-0 flex-1 items-center xl:mb-3"></div>
		}
	</div>
</div>
